/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from "react"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import BackButton from "../../../../components/Tablet/BackButton"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"
import { setAlerts } from "../../../../globalStore/alertStore"
import {
  TenkoDetailContext,
  UpsertTenkoDetailFunctionContext,
} from "../../context/context"
import { CSS_PROPERTY } from "../../cssProperties/tablet"

/**
 * その他報告事項
 * @returns
 */
const SonotaHokoku = () => {
  const dispatch: AppDispatch = useDispatch()
  const { 点呼明細 } = useContext(TenkoDetailContext)

  const UpsertTenkoDetailFunction = useContext(UpsertTenkoDetailFunctionContext)

  const upsert点呼明細 = async () => {
    try {
      await UpsertTenkoDetailFunction()
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>その他・報告事項</td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div
                style={{
                  height: "20rem",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  backgroundColor: "white",
                  marginBottom: "1rem",
                  padding: "2rem",
                  verticalAlign: "top",
                }}>
                <div>
                  {" "}
                  {点呼明細?.報告事項テキスト && 点呼明細?.報告事項テキスト}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td className="text-end">
              <div
                className="d-inline-block"
                onTouchStart={upsert点呼明細}
                style={{
                  bottom: "0",
                  backgroundColor: CSS_PROPERTY.WARN_COLOR,
                  color: "white",
                  width: "25rem",
                  textAlign: "center",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                }}>
                <span>点呼終わり</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SonotaHokoku
